import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Tradeplate from './tradeplate.jsx';

export default class ThisDriversArchivedTradeplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/tradeplates',
      tradeplateAccountId: props.tradeplateAccountId || null,
    };
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/tradeplates/'+
      this.state.tradeplateAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(tradeplatesJson) {
      that.setState({
        tradeplates: tradeplatesJson,
        isLoading: false
      });
    });
  }

  render() {
    var Tradeplatearr = [];

    if (this.state.tradeplates && this.state.tradeplates.length > 0) {
      this.state.tradeplates.forEach(function(i) {
          Tradeplatearr.push(<Tradeplate key={'tradeplate-'+i.id} data={i} />);
        });
    }
    return (
        <div>
            <div className="row tradeplates-table-header">
                <div className="col-md-3">
                    description
                </div>
                <div className="col-md-3">
                    reference
                </div>
                <div className="col-md-2">
                    amounts
                </div>
                <div className="col-md-2">
                    frequency
                </div>
                <div className="col-md-2">
                    details
                </div>
            </div>
            {Tradeplatearr}
        </div>
    );
  }
}
